/**
 * Games Info Model for Winner
 */

define(function(require, exports, module) {
    'use strict';

    var GamesInfoGameModel = require('portlets/games-info/gamesinfo.game.model');

    module.exports = GamesInfoGameModel.extend({

        initialize: function(attrs) {
            this.extractFilterTagsFromDescription(attrs);

            GamesInfoGameModel.prototype.initialize.apply(this, arguments);
        },

        getTags: function(attrs) {
            var tags;

            if (typeof attrs.description === 'string') {
                tags = (tags = attrs.description.match(/{{{(.*?)}}}/)) && tags[1] ? tags[1] : null;
            }

            return tags && tags.replace(/\n|\s/g, '').split(',') || [];
        },

        extractFilterTagsFromDescription: function(attrs) {
            var tags = this.getTags(attrs);
            var description = attrs.description;

            if (typeof description === 'string') {
                description = description.replace(/{{{(.*?)}}}/g, '');
            }

            this.set({
                filterTags: tags,
                description: description
            });
        }

    });
});
